import React, { ReactNode, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { AnimatePresence, motion } from "framer-motion";
import { IconType } from "react-icons";

interface PopupContainerProps {
  id?: string;
  icon: IconType;
  title: string | undefined;
  children: ReactNode;
}

const PopupContainer: React.FC<PopupContainerProps> = ({
  id = "scratch-pop-up-option",
  icon: Icon,
  title,
  children,
}) => {
  // States defintion
  const [open, setOpen] = useState(false);

  return (
    <div id={id} className="flex-row h-fit w-fit">
      {open && (
        <div
          className="fixed top-0 left-0 w-screen h-screen bg-transparent z-30"
          onClick={() => setOpen(false)}
        />
      )}
      <div
        className={`h-[94px] p-3 rounded-full justify-center items-center gap-1 inline-flex ${
          !open && "cursor-pointer"
        }`}
        onClick={() => setOpen(!open)}
      >
        {/* Icon and title */}
        <div className="flex-col justify-center items-center gap-2 inline-flex">
          <div className="p-3 bg-Canvas hover:bg-neutral-100 ease-in-out duration-150 rounded-full backdrop-blur-[32px] justify-center items-center gap-2 inline-flex">
            <Icon className="w-6 h-6 text-secondary-600" />
          </div>
          {title && (
            <div className="text-center text-secondary-600 text-xs font-semibold font-poppins uppercase leading-[14px] tracking-wide select-none">
              {title}
            </div>
          )}
        </div>
        {/* Spinning arrow */}
        <div className="flex-col justify-center items-center gap-2 inline-flex">
          <motion.div
            className="w-4 h-4 relative"
            initial={{ rotate: 0 }}
            animate={{ rotate: open ? -180 : 0 }}
          >
            <MdArrowDropDown className="w-full h-full text-secondary-600" />
          </motion.div>
          <div className="opacity-0 justify-start items-start gap-2 inline-flex">
            <div className="text-center text-secondary-600 text-xs font-semibold font-poppins uppercase leading-[14px] tracking-wide">
              F
            </div>
          </div>
        </div>
      </div>
      {/* Pop up options */}
      <AnimatePresence>
        {open && (
          <div
            className="relative w-full h-0 mr-0"
            // Close after clicking an option
            onClick={() => setOpen(false)}
          >
            {children}
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PopupContainer;
